import {Injectable} from '@angular/core';
import {ApplicationSettingsHelper} from '~/app/shared/helpers/application-settings-helper';

declare let gtag: Function;

@Injectable({
    providedIn: 'root'
})

export class GoogleAnalyticsService {

    constructor(public applicationSettingsHelper: ApplicationSettingsHelper) {
    }

    public eventEmitter(
        eventAction: string,
        eventCategory: string,
        eventLabel: string,
        eventValue: number) {
        gtag('event', eventAction, {
            'event_category': eventCategory,
            'event_label': eventLabel,
            'value': eventValue
        });
    }

    public initializeGoogleAnalytics() {
    }

    public initAnalytics() {
    }

    // public errorEmit(errorJson: string) {
    //     gtag('send', 'exception', {
    //         'exDescription': errorJson,
    //         'exFatal': false
    //     });
    // }

}
